import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import WaterTowersTable from './water-towers-table';
import WaterTowersTile from './water-towers-tile';
import WaterTowersSearch from './water-towers-search';
import WaterTowersNavBar from './water-towers-nav-bar';

const WaterTowersContent = props => {
  const [activeLane, setActiveLane] = useState('ALL');
  const tileView = useSelector(state => state.waterTowers?.tileView ?? true);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top w-100">
          <WaterTowersSearch />
        </div>
        <div className="d-flex">
          <WaterTowersNavBar onLaneChange={setActiveLane} activeLane={activeLane} />
          {!tileView ? <WaterTowersTable activeLane={activeLane} /> : <WaterTowersTile />}
        </div>
      </div>
    </div>
  );
};

export default WaterTowersContent;
